import { render, staticRenderFns } from "./InterestAssessment.vue?vue&type=template&id=1d7f1628&"
import script from "./InterestAssessment.vue?vue&type=script&lang=js&"
export * from "./InterestAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports